a.qrscanner = (function(){
	var my = {
		html5QrCode:undefined,
		open:function(o){
			var cb_result = o.result || function(){};
			var scanRaw = o.scanRaw || false;
			tpl.run({
				tpl:'/tpl/qrscanner.ejs?v='+v,
				data:{},
				cb:function(c){
					var token = a.popup.create({
						slideFrom:'fromtop',
						title:'Scan QR code',
						content:c,
						disable_topbar:false,
						disable_back:false,
						css_class:'qrscanner',
						ready:function(token){
							var win = $('#popupid_'+token);
							// Init QR reader
							my.html5QrCode = new Html5Qrcode("reader");
							var qrCodeSuccessCallback = function(code) {
								if (scanRaw) {
									my.returnCode(code,cb_result);
								}
								else {
									my.findItem(code,function(iid){
										window.history.back();
										setTimeout(function(){
											a.item.display.popup(iid);
										},400);
									},function(){
										a.s.growl.create('Item not found','The QR code was not recognized, please try again or select the item manually',{ duration:4000 });
									});
								}
							}
							var qrCodeErrorCallback = function(message) {
								
							}
							var config = {
								fps: 10,
								qrbox: 250
							};
							my.html5QrCode.start({
								facingMode: "environment"
							}, config, qrCodeSuccessCallback,qrCodeErrorCallback);

							$('li[data-action="close"]',win).unbind('click').click(function(){
								window.history.back();
							});
						},
						close:function(){
							my.html5QrCode.stop();
							my.html5QrCode = undefined;
						}
					});
				}
			});
		},
		returnCode:debounce(function(code,cb){
			cb(code);
			window.history.back();
		},500,true),
		findItem:debounce(function(uuid,cb_success,cb_failed){
			var data = {};
			data.qrid = uuid;
			data.token = localStorage.getItem('token');
			data.accountname = localStorage.getItem('accountname');
			// Search for item
			$.ajax({
				type:'GET',
				url:'/api/item/load/',
				data:data,
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success && result.item) {
						cb_success(result.item.id);
					}
					else {
						cb_failed();
					}
				}
			}).done(function(){});
		},500,true)
	}
	return my;
}());